var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u8-rank-list" },
    _vm._l(_vm.ranks, function (item, index) {
      return _c("RankItem", {
        attrs: {
          currVal: item.value,
          percentage: item.percentage,
          title: item.title,
          desc: item.desc,
          index: index,
          color: item.color,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }